import { render, staticRenderFns } from "./HousingNav.vue?vue&type=template&id=4f59e9f3&scoped=true&"
import script from "./HousingNav.vue?vue&type=script&lang=js&"
export * from "./HousingNav.vue?vue&type=script&lang=js&"
import style0 from "./HousingNav.vue?vue&type=style&index=0&id=4f59e9f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f59e9f3",
  null
  
)

export default component.exports